import { Injectable, ViewContainerRef } from '@angular/core';

export class ViewContainerRefModel {
  viewRefs: ViewContainerRef[] = [];
}

@Injectable()
export class ViewContainerRefService {
  refsModel = new ViewContainerRefModel();

  public setViewRef(ref: any) {
    this.refsModel.viewRefs = [...this.refsModel.viewRefs, ref];
  }

  public getViewRefs(): ViewContainerRef[] {
    return this.refsModel.viewRefs;
  }
}
